
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careerguide/quiz",
      function () {
        return require("private-next-pages/careerguide/quiz/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careerguide/quiz"])
      });
    }
  